import { EyeTrackingClient, logger } from '@cutwise/utils';

type EyeTrackingState = 'pending' | 'started' | 'failed';

class EyeTracking {
  state: EyeTrackingState = 'pending';

  #client: EyeTrackingClient;

  constructor() {
    this.#client = new EyeTrackingClient();

    this.#start();
  }

  close() {
    this.#client.disconnect();
  }

  #start() {
    this.#client.onError = () => {
      this.state = 'failed';
    };

    this.#client.onSuccess = () => {
      logger.info('Eye tracking extensions is started!');

      this.state = 'started';
    };

    this.#client.connect();
  }
}

const eyeTracking = new EyeTracking();

export { eyeTracking };
